// aip.aegion.com
const HTTPS_URL = 'https://api.aip.aegion.com';
const WS_URL = 'wss://ws.aip.aegion.com';

const TAB_PREFIX = '';
const TAB_SUFFIX = 'AIP';

const aipurls = {
  bucket: 'aegion-aip-prod-nonversioned',
	clientid: '75b6s763dilenknkm6mb38va7f',
	identifypoolid: 'us-west-2:58ed4f86-2329-4853-9a36-057f874bc5d9',
	poolid: 'cognito-idp.us-west-2.amazonaws.com/us-west-2_8bd8llCAP',
	mlServerApi: 'https://ml.aip.aegion.com/',
  uploaderbucket: 'aegion-aip-prod',
  cisvFileUploadBucket: 'aip-cisline-prod-file-upload',
	versionedBucket: 'aegion-aip-prod',


  account: `${HTTPS_URL}/account`,
  admin: `${HTTPS_URL}/admin`,
  assetview: `${HTTPS_URL}/assetview`,
  assetviewCorrelator: `${HTTPS_URL}/assetview-correlator`,
  assetviewWS: `${WS_URL}/assetview`,
  chargeline: `${HTTPS_URL}/chargeline`,
  chargelinebinary: `${HTTPS_URL}/chargeline-binary`,
  cisview: `${HTTPS_URL}/cisview`,
  cisviewedits: `${HTTPS_URL}/cisview-edits`,
  cisviewextended: `${HTTPS_URL}/cisview-extended`,
  cisviewreadonly: `${HTTPS_URL}/cisview-readonly`,
  customercreated: `${HTTPS_URL}/customer-created`,
  customerusers: `${HTTPS_URL}/customer-users`,
  dashboard: `${HTTPS_URL}/dashboard`,
  dataIntegrity: `${HTTPS_URL}/dataIntegrity`,
  downloadReport: `${HTTPS_URL}/dataprocessor-report`,
  fieldline: `${HTTPS_URL}/fieldline`,
  fieldlinebinary: `${HTTPS_URL}/fieldline-binary`,
  fieldlineloader: `${HTTPS_URL}/fieldline-loader`,
  liveline: `${HTTPS_URL}/liveline`,
  maps: `${HTTPS_URL}/maps`,
  mlServerLambdaApi: `${HTTPS_URL}/ml/`,
  notifications: `${HTTPS_URL}/aip-notifications`,
  parseFile: `${HTTPS_URL}/parse-file`,
  parseFileWS: `${WS_URL}/parse-file`,
  platform: `${HTTPS_URL}/platform`,
  scanline: `${HTTPS_URL}/scanline`,
  scanlineaggregates: `${HTTPS_URL}/scan-aggs`,
  scanlineReport: `${HTTPS_URL}/scanlineReport`,
  scanlineReportV2: `${HTTPS_URL}/scanline-report-v2`,
  scanlineReportV2WS: `${WS_URL}/scanline-report-v2`,
  scanlineTags: `${HTTPS_URL}/scanline-tags`,
  scanlineWorkflow: `${HTTPS_URL}/scanline-workflow`,
  settings: `${HTTPS_URL}/settings`,
  stationalignment: `${HTTPS_URL}/station-alignment`,
  reportgeneration: `${HTTPS_URL}/report-generation`,
  templates: `${HTTPS_URL}/templates`,
  templateViewer: `${HTTPS_URL}/internal-template-viewer-2`,
  uploaderbucketaccessurl: `${HTTPS_URL}/uploader/access`,
  uploaderfilesubmiturl: `${HTTPS_URL}/cisview-extended/postUploaderSubmit`,
  uploaderwebsocket: `${WS_URL}/uploader`,
  uploderbucketbasepath: `${HTTPS_URL}/uploader`,
  viewAs: `${HTTPS_URL}/view-as`,
};

const URL = HTTPS_URL;

export default aipurls;

export { URL, TAB_PREFIX, TAB_SUFFIX };